import { z } from "zod";
import { TopolBlockCssClassSchema, TopolBlockSchema } from "../commonSchema";

export const TopolRawBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-raw"),
  content: z.string().catch(""),
  custom: z.literal(true).optional().catch(undefined),
  key: z.string().optional().catch(undefined),
  attributes: z
    .object({
      containerWidth: z.number().catch(600),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .catch({
      containerWidth: 600,
    }),
});

export type TopolRawBlock = z.infer<typeof TopolRawBlockSchema>;
